export const filterConfig = {
    delimiterGroups: ";",
    delimiterValues: ",",
    delimiterGroupValue: ":",
    groups: {
        select: ["groesse", "alter"],
        contact: ["treff", "location", "zeiten"],
    },
    apiFetchDebounceMs: 200,
}
